export default {
    workOrder_createEdit_createTitle: "Crear Nueva Orden de Trabajo",
    workOrder_createEdit_editTitle: "Editar Orden de Trabajo",
    workOrder_createEdit_settings: "Ajustes",
    workOrder_createEdit_comments: "Comentarios",
    workOrder_createEdit_historyLogs: "Registros Históricos",
    workOrder_createEdit_warning: "Advertencia!",
    workOrder_createEdit_warningMessage: "¿Está seguro de que desea cerrar el editor de órdenes de trabajo? Los cambios no guardados se perderán.",
};